"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyLastCardUpSetting = void 0;
var BuyLastCardUpSetting;
(function (BuyLastCardUpSetting) {
    BuyLastCardUpSetting[BuyLastCardUpSetting["DISABLED"] = 0] = "DISABLED";
    BuyLastCardUpSetting[BuyLastCardUpSetting["ENABLED"] = 1] = "ENABLED";
})(BuyLastCardUpSetting || (exports.BuyLastCardUpSetting = BuyLastCardUpSetting = {}));
//# sourceMappingURL=BuyLastCardUpSetting.js.map